import React from 'react';
import FailedScanNote from '@/components/creator-vetting-report/components/failed-scan-note';
import {FailedFlagWithCategory} from '../../hooks/use-get-vetting-categories/useGetVettingCategories';
import ProfileVettingContentItem from '../profile-vetting-content-item';
import styles from './ProfileVettingFailedContent.module.scss';

interface ProfileVettingFlaggedContentProps {
  reportId: string;
  failedContent: FailedFlagWithCategory;
  onPostClick: (flag: string, postId: string) => void;
  trackAction: (actionName: string, actionValue: string) => void;
}

function ProfileVettingFailedContent(props: ProfileVettingFlaggedContentProps) {
  const {reportId, failedContent, onPostClick, trackAction} = props;

  return (
    <div className={styles.profileVettingFailedContentContainer}>
      <FailedScanNote />
      <ProfileVettingContentItem
        reportId={reportId}
        key={failedContent.id}
        item={failedContent}
        showFlagName={false}
        showTopDivider={false}
        onPostClick={onPostClick}
        trackAction={trackAction}
      />
    </div>
  );
}

export default ProfileVettingFailedContent;
